import { Link } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

/** A page this account may not open — the empty-state shape: lime disc, one line, one way out. */
export default function UnauthorizedPage() {
  const { t } = useLanguage();
  return (
    <main className="flex min-h-screen items-center justify-center p-4">
      <div className="card-soft flex w-full max-w-md flex-col items-center gap-3 p-8 text-center">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-lime text-accent-foreground">
          <ShieldAlert className="h-8 w-8" strokeWidth={1.8} aria-hidden="true" />
        </span>
        <h1 className="mt-1 text-2xl font-semibold text-ink">{t('roles.notAllowedTitle')}</h1>
        <p className="text-[15px] text-helper">{t('roles.notAllowedBody')}</p>
        <Link
          to="/home"
          className="mt-3 inline-flex h-12 items-center rounded-full bg-primary px-8 font-semibold text-primary-foreground"
        >
          {t('common.close')}
        </Link>
      </div>
    </main>
  );
}
